import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';

import { removeTask, updateTask } from 'bundles/project/actions/index';
import { completeTask, newLeadTask } from 'bundles/project/actions/lead_tasks';
import { tasksForLead } from 'bundles/project/selectors/leads';
import { getAssigneeOptions, getAvailableDatabaseOptions } from 'bundles/project/selectors/index';

import TaskList from 'components/tasks/task_list';
import {
  getHideContactSelect,
  getHidePropertySelect,
} from 'bundles/project/selectors/tasks';

export class Tasks extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.array.isRequired,
    databaseMembers: PropTypes.array.isRequired,
    hideContactSelect: PropTypes.bool,
    hidePropertySelect: PropTypes.bool,
    lead: PropTypes.object,
    tasks: PropTypes.array.isRequired,
    onDeleteTask: PropTypes.func.isRequired,
    onNewTask: PropTypes.func.isRequired,
    onTaskComplete: PropTypes.func.isRequired,
    onUpdateTask: PropTypes.func.isRequired,
  };

  render() {
    return (
      <React.Fragment>
        {this.renderHeader()}
        {this.renderTasks()}
      </React.Fragment>
    );
  }

  renderHeader() {
    const { onNewTask, lead } = this.props;

    return (
      <div className="mb-3">
        <div className="pull-right">
          <button className="btn btn-link p-0" name="new-task-button" onClick={() => onNewTask(lead)}>
            + Add Task
          </button>
        </div>
        <FontAwesomeIcon className="mr-2" fixedWidth icon={faCheck} size="1x" />
        <span className="h3">Tasks</span>
      </div>
    );
  }

  renderTasks() {
    const {
      availableDatabases,
      databaseMembers,
      hideContactSelect,
      hidePropertySelect,
      tasks,
      onDeleteTask,
      onUpdateTask,
      onTaskComplete
    } = this.props;

    return (
      <table className="table table-condensed contacts-tasks">
        <tbody>
          <TaskList
            availableDatabases={availableDatabases}
            databaseMembers={databaseMembers}
            hideActions
            hideAssociations
            hideContactSelect={hideContactSelect}
            hidePropertySelect={hidePropertySelect}
            multipleProjectsInTask={true}
            tasks={tasks}
            onDeleteTask={onDeleteTask}
            onToggleTaskState={onTaskComplete}
            onUpdateTask={onUpdateTask}
          />
        </tbody>
      </table>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  availableDatabases: getAvailableDatabaseOptions(state),
  databaseMembers: getAssigneeOptions(state),
  hideContactSelect: getHideContactSelect(state),
  hidePropertySelect: getHidePropertySelect(state),
  tasks: tasksForLead(ownProps.lead, state.tasks)
});

const mapDispatchToProps = {
  onDeleteTask: removeTask,
  onNewTask: newLeadTask,
  onTaskComplete: completeTask,
  onUpdateTask: updateTask
};

export default connect(mapStateToProps, mapDispatchToProps)(Tasks);
